/* eslint-disable */


/**
 * Create styles for `<TermsAndConditionsLink />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<TermsAndConditionsLink />` styles
 */
const termsAndConditionsLinkStyles = ({ theme }) => ({
  link: {
    color: `inherit`,
  },
  wrapper: {
    fontSize: `12px`,
    marginBottom: `2em`,
    textAlign: 'center',
    margin: '0 auto',
  },
  wrapperSm: {
    maxWidth: '280px',
  },
  termsAndConditions: {
    color: '#ccc',
    fontSize: '12px',
  },
});

export default termsAndConditionsLinkStyles;
